import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center bg-[#D6E6F2]"
            >
                <div className="h-10 w-10 rounded-full border-2 border-[#1E56A0] border-t-transparent animate-spin" />
            </div>
        );
    }

    if (status !== "authed" || !user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (roles && roles.length > 0 && !roles.includes(user.role)) {
        return <Navigate to="/forbidden" replace />;
    }

    return children;
}
